<template>
    <div>
        <div id="zzjs_net_1" style="left: 2px; position: absolute; top: 20px;">
            <img src="../../assets/images/duilian_left.jpg" />
        </div>
        <div id="zzjs_net_2" style="right: 2px; position: absolute; top: 20px;">
            <img src="../../assets/images/duilian_right.jpg" />
        </div>

            <table style="width:auto;" border="0" align="center" cellpadding="0" cellspacing="0">
                <tbody>
                <tr>
                    <td height="300" valign="top" bgcolor="#FFFFFF">
                        <table width="1000" border="0" align="center" cellpadding="0" cellspacing="0">
                            <tbody>
                            <tr>
                                <td height="276">
                                    <div id="HeaderBorder">
                                        <div id="slideshow">
                                            <div class="" style="opacity: 1;">
                                                <img src="../../assets/images/banner0.jpg" alt="" width="1000" height="276" />
                                            </div>
                                            <div class="current" style="opacity: 1;">
                                                <img src="../../assets/images/banner1.jpg" alt="" width="1000" height="276" />
                                            </div>
                                        </div>
                                    </div> </td>
                            </tr>
                            </tbody>
                        </table>
                        <table width="1000" border="0" align="center" cellpadding="0" cellspacing="0">
                            <tbody>
                            <tr>
                                <td style="height:6px;"></td>
                            </tr>
                            </tbody>
                        </table>
                        <table width="1000" border="0" align="center" cellpadding="0" cellspacing="0">
                            <tbody>
                            <tr>
                                <td height="45" align="center" class="NavBarBg">
                                    <router-link :to="'/fifty'" >50周年庆</router-link>
                                    <router-link :to="'/fifty-news-list/199'">通知公告</router-link>
                                    <router-link :to="'/fifty-news-list/200'">院庆新闻</router-link>
                                    <router-link :to="'/fifty-news-list/201'">院庆征文</router-link>
                                    <router-link :to="'/fifty-news-list/202'">活动安排</router-link>
                                    <router-link :to="'/fifty-news-list/203'">院庆剪影</router-link>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <table width="1000" border="0" align="center" cellpadding="0" cellspacing="0">
                            <tbody>
                            <tr>
                                <td style="height:6px;"></td>
                            </tr>
                            </tbody>
                        </table>
                        </td>
                </tr>
                </tbody>
            </table>
    </div>
</template>
<style scoped>

    ul,li{margin:0px; padding:0px;list-style:none;}
    .scroll_div {width:1000px; height:128px;margin:0 auto; overflow: hidden; white-space: nowrap; background:#ffffff; }
    .scroll_div img {padding-top:0px;padding-bottom:0px;width:190px;height:120px;border:0px #000 solid;margin:0px;margin-left:8px; border:0px #cccccc solid;}
    #scroll_begin, #scroll_end, #scroll_begin ul, #scroll_end ul, #scroll_begin ul li, #scroll_end ul li{display:inline;}/*设置ul和li横排*/
    #zzjs_net_1,#zzjs_net_2{
        width:120px;
        height:425px;
        z-index:9999;
    }
</style>
<script>
    export default {
        name: 'Header',
        data(){
            return{

            }
        },
        methods:{

        }
    }
</script>